export const TransactionTypeEnum = {
  1: "Top Up",
  2: "Fanoos Fee",
  3: "Incentive",
  4: "Adjustment",
  5: "Withdrawal",
  6: "Transaction Fee",
  7: "Cancellation Fees",
  8: "Refund",
};

export const TransactionTypeOptions = Object.entries(TransactionTypeEnum).map(([value, label]) => ({ value: String(value), label }));
